// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filter-container {
  height: 40px;
  border-radius: 10px;
  border: 1px solid #DFE2EA;
  display: flex;
  align-items: center;
  padding-inline-start: 10px;
  background: #F4F5F8;
  cursor: pointer;
}

.filter-container .filter-icon {
  margin-inline-end: 10px;
  background: url("/assets/media/general/filter.svg") no-repeat center;
  width: 20px;
  height: 20px;
}

.filter-container .filter-end {
  width: 40px;
  height: 100%;
  background: #30F;
  border-start-end-radius: 5px;
  border-end-end-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.filter-container .filter-end .end-icon {
  background: url("/assets/media/general/arrow-down.svg") no-repeat center;
  width: 20px;
  height: 20px;
}

.filter-label {
  font-size: 16px;
  font-weight: 600;
  color: #575962;
  padding-inline-start: 10px;
  padding-inline-end: 20px;
  flex: 1;
}

.main-filter-container {
  position: relative;
}

.filter-dropdown-container {
  z-index: 10;
  background-color: #ffffff;
  border-radius: 0.5rem;
  /* 8px - corresponds to rounded-lg */
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1);
  /* shadow */
  position: absolute;
  right: 0;
  padding: 0.25rem;
  /* p-1 (4px) */
  width: 100%;
  margin-top: 5px;
}
.filter-dropdown-container ::ng-deep .custom-input,
.filter-dropdown-container ::ng-deep label,
.filter-dropdown-container ::ng-deep .error-label,
.filter-dropdown-container ::ng-deep .ng-select .ng-select-container,
.filter-dropdown-container ::ng-deep .ng-option,
.filter-dropdown-container ::ng-deep .ng-value-label,
.filter-dropdown-container ::ng-deep input::placeholder,
.filter-dropdown-container ::ng-deep .form-control,
.filter-dropdown-container ::ng-deep input,
.filter-dropdown-container ::ng-deep select,
.filter-dropdown-container ::ng-deep textarea {
  font-family: inherit !important;
}

/* For divide-y divide-gray-100 */
.filter-dropdown-container > :not([hidden]) ~ :not([hidden]) {
  border-top-width: 1px;
  border-color: #f3f4f6;
  /* gray-100 */
}

.applied-filters-bar {
  padding: 10px;
  border-radius: 5px;
}

.applied-filter-item {
  display: flex;
  align-items: center;
  background-color: #FFFFFF;
  border: 1px solid #DFE2EA;
  border-radius: 5px;
  padding: 5px 10px;
}

.btn-clear-filter {
  background: none;
  border: none;
  color: #FF0000;
  margin-left: 5px;
  cursor: pointer;
}

.applied-filters-static-bar {
  padding: 10px;
  border-radius: 5px;
  display: flex;
  gap: 8px;
  flex-wrap: nowrap;
  overflow-x: hidden;
  width: 100%;
}

.applied-filter-static-item {
  display: flex;
  align-items: center;
  padding: 2px 8px;
  white-space: nowrap;
  color: #666;
  font-size: 0.9em;
}
.applied-filter-static-item:not(:last-child) {
  border-right: 1px solid #ddd;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/filter-v2/filter-v2.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,0BAAA;EACA,mBAAA;EACA,eAAA;AACF;;AAEA;EACE,uBAAA;EACA,oEAAA;EACA,WAAA;EACA,YAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,4BAAA;EACA,0BAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;AAAF;;AAGA;EACE,wEAAA;EACA,WAAA;EACA,YAAA;AAAF;;AAGA;EAEE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,0BAAA;EACA,wBAAA;EACA,OAAA;AADF;;AAIA;EACE,kBAAA;AADF;;AAKA;EACE,WAAA;EACA,yBAAA;EACA,qBAAA;EACA,oCAAA;EACA,6EAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,gBAAA;EACA,cAAA;EACA,WAAA;EACA,eAAA;AAFF;AAMI;;;;;;;;;;;EAWE,+BAAA;AAJN;;AASA,iCAAA;AACA;EACE,qBAAA;EACA,qBAAA;EACA,aAAA;AANF;;AASA;EACE,aAAA;EAEA,kBAAA;AAPF;;AAUA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;AAPF;;AAUA;EACE,gBAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AAPF;;AAUA;EACE,aAAA;EACA,kBAAA;EACA,aAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;AAPF;;AAWA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;AARF;AAUE;EACE,4BAAA;AARJ","sourcesContent":[".filter-container {\n  height: 40px;\n  border-radius: 10px;\n  border: 1px solid #DFE2EA;\n  display: flex;\n  align-items: center;\n  padding-inline-start: 10px;\n  background: #F4F5F8;\n  cursor: pointer;\n}\n\n.filter-container .filter-icon {\n  margin-inline-end: 10px;\n  background: url('/assets/media/general/filter.svg') no-repeat center;\n  width: 20px;\n  height: 20px;\n}\n\n.filter-container .filter-end {\n  width: 40px;\n  height: 100%;\n  background: #30F;\n  border-start-end-radius: 5px;\n  border-end-end-radius: 5px;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.filter-container .filter-end .end-icon {\n  background: url('/assets/media/general/arrow-down.svg') no-repeat center;\n  width: 20px;\n  height: 20px;\n}\n\n.filter-label {\n  // font-family: Cairo;\n  font-size: 16px;\n  font-weight: 600;\n  color: #575962;\n  padding-inline-start: 10px;\n  padding-inline-end: 20px;\n  flex: 1;\n}\n\n.main-filter-container {\n  position: relative;\n}\n\n\n.filter-dropdown-container {\n  z-index: 10;\n  background-color: #ffffff;\n  border-radius: 0.5rem;\n  /* 8px - corresponds to rounded-lg */\n  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);\n  /* shadow */\n  position: absolute;\n  right: 0;\n  padding: 0.25rem;\n  /* p-1 (4px) */\n  width: 100%;\n  margin-top: 5px;\n\n  ::ng-deep {\n\n    .custom-input,\n    label,\n    .error-label,\n    .ng-select .ng-select-container,\n    .ng-option,\n    .ng-value-label,\n    input::placeholder,\n    .form-control,\n    input,\n    select,\n    textarea {\n      font-family: inherit !important;\n    }\n  }\n}\n\n/* For divide-y divide-gray-100 */\n.filter-dropdown-container> :not([hidden])~ :not([hidden]) {\n  border-top-width: 1px;\n  border-color: #f3f4f6;\n  /* gray-100 */\n}\n\n.applied-filters-bar {\n  padding: 10px;\n  // background-color: #F4F5F8;\n  border-radius: 5px;\n}\n\n.applied-filter-item {\n  display: flex;\n  align-items: center;\n  background-color: #FFFFFF;\n  border: 1px solid #DFE2EA;\n  border-radius: 5px;\n  padding: 5px 10px;\n}\n\n.btn-clear-filter {\n  background: none;\n  border: none;\n  color: #FF0000;\n  margin-left: 5px;\n  cursor: pointer;\n}\n\n.applied-filters-static-bar {\n  padding: 10px;\n  border-radius: 5px;\n  display: flex;\n  gap: 8px;\n  flex-wrap: nowrap; // Prevent wrapping\n  overflow-x: hidden; // Hide horizontal overflow\n  width: 100%;\n\n}\n\n.applied-filter-static-item {\n  display: flex;\n  align-items: center;\n  padding: 2px 8px;\n  white-space: nowrap; // Keep text in single line\n  color: #666; // Example text color\n  font-size: 0.9em;\n\n  &:not(:last-child) {\n    border-right: 1px solid #ddd;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
